import React from "react";

type CustomerType = "regular" | "vip" | "vvip";

interface CustomerTypeBadgeProps {
  type: CustomerType;
}

export const CustomerTypeBadge: React.FC<CustomerTypeBadgeProps> = ({
  type,
}) => {
  const getTypeStyles = (type: CustomerType) => {
    switch (type) {
      case "regular":
        return {
          bg: "bg-blue-900",
          text: "text-blue-300",
          label: "Regular",
        };
      case "vip":
        return {
          bg: "bg-orange-600",
          text: "text-orange-100",
          label: "VIP",
        };
      case "vvip":
        return {
          bg: "bg-amber-900",
          text: "text-amber-300",
          label: "VVIP",
        };
      default:
        return {
          bg: "bg-blue-900",
          text: "text-blue-300",
          label: "Regular",
        };
    }
  };

  const styles = getTypeStyles(type);

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${styles.bg} ${styles.text}`}
    >
      {styles.label}
    </span>
  );
};
